import {AnyTableColumn} from '@fl/cmsch-fe-library';
import {ReactNode} from 'react';

import {TFunction} from 'app/translations';

import {getAnimalBrowserLink} from '../../utils';

export interface RecalcMatingPrefsRow {
    /** Stable row id. */
    id: number;
    /** Bull line registry or the total label. */
    rowName?: string;
    /** Optional bull display name. */
    bullName?: string;
    /** Editable preference percentage or a rendered total cell. */
    percentage?: ReactNode;
    /** Rank 1 count. */
    rank1Count?: number;
    /** Rank 1 share. */
    rank1Share?: number;
    /** Rank 2 count. */
    rank2Count?: number;
    /** Rank 2 share. */
    rank2Share?: number;
    /** Rank 3 count. */
    rank3Count?: number;
    /** Rank 3 share. */
    rank3Share?: number;
    /** Rank 4 count. */
    rank4Count?: number;
    /** Rank 4 share. */
    rank4Share?: number;
    /** Rank 5 count. */
    rank5Count?: number;
    /** Rank 5 share. */
    rank5Share?: number;
}

/**
 * Builds the columns for the mating preference table.
 *
 * @param t Mating translation function.
 * @returns Table columns for the bull preference table.
 */
// eslint-disable-next-line max-lines-per-function
export const buildMatingPreferencesColumns = (
    t: TFunction<'mating'>,
): Array<AnyTableColumn<RecalcMatingPrefsRow>> => [
    {
        field: 'rowName',
        column: t('lineRegistryShort'),
        type: 'hyperlink',
        valueToUrl: (value: string) => value === t('total') ? null : getAnimalBrowserLink(value),
        openInNewTab: true,
        width: 100,
        disableFilter: true,
    },
    {
        field: 'bullName',
        column: t('name'),
        type: 'string',
        width: 100,
        disableFilter: true,
    },
    {
        field: 'percentage',
        column: '%',
        type: 'reactNode',
        width: 90,
        disableFilter: true,
    },
    {
        column: t('bull', {number: 1}),
        type: 'grouping',
        subColumns: [
            {
                field: 'rank1Count',
                column: t('frequency'),
                type: 'number',
                disableFilter: true,
            },
            {
                field: 'rank1Share',
                column: t('share'),
                type: 'number',
                disableFilter: true,
            },
        ],
    },
    {
        column: t('bull', {number: 2}),
        type: 'grouping',
        subColumns: [
            {
                field: 'rank2Count',
                column: t('frequency'),
                type: 'number',
                disableFilter: true,
            },
            {
                field: 'rank2Share',
                column: t('share'),
                type: 'number',
                disableFilter: true,
            },
        ],
    },
    {
        column: t('bull', {number: 3}),
        type: 'grouping',
        subColumns: [
            {
                field: 'rank3Count',
                column: t('frequency'),
                type: 'number',
                disableFilter: true,
            },
            {
                field: 'rank3Share',
                column: t('share'),
                type: 'number',
                disableFilter: true,
            },
        ],
    },
    {
        column: t('bull', {number: 4}),
        type: 'grouping',
        subColumns: [
            {
                field: 'rank4Count',
                column: t('frequency'),
                type: 'number',
                disableFilter: true,
            },
            {
                field: 'rank4Share',
                column: t('share'),
                type: 'number',
                disableFilter: true,
            },
        ],
    },
    {
        column: t('bull', {number: 5}),
        type: 'grouping',
        subColumns: [
            {
                field: 'rank5Count',
                column: t('frequency'),
                type: 'number',
                disableFilter: true,
            },
            {
                field: 'rank5Share',
                column: t('share'),
                type: 'number',
                disableFilter: true,
            },
        ],
    },
];
